import { Box } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../constant";
import useLongMachineSetting from "../../hook/useLongMachineSetting";
import { useMemo } from "react";
import useDomainConfig from "../../hook/useDomainConfig";

const LongMachineVideo = () => {
  const { longMachineVideoHeight } = useLongMachineSetting();

  const { videoUrl } = useDomainConfig();

  return (
    <>
      <Box
        zIndex={999999}
        bgImage={`url(${COMMON_WEB_PATH}/now888/header/long_machine_demo_banner.png)`}
        bgSize="100%100%"
        bgPosition="center"
        bgRepeat="no-repeat"
        h={longMachineVideoHeight}
        w="100%"
        mb="10px"
        position="fixed"
        top="0"
      >
        <Box
          as="video"
          w="100%"
          h="100%"
          title="video"
          src={videoUrl}
          loop
          autoPlay
          objectFit={"fill"}
          muted
        ></Box>
      </Box>
    </>
  );
};

export default LongMachineVideo;
